import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["deviceTypesWithSticky", "stickyClassNames", "onBottomStuck", "onTopStuck"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useMemo, useState } from 'react';
import { useDeviceType } from '@cian/ui-kit/responsive';
export var useStickyActionsProps = function useStickyActionsProps(props) {
  var deviceTypesWithSticky = props.deviceTypesWithSticky,
    stickyClassNames = props.stickyClassNames,
    onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBottomStuck = _useState2[0],
    setIsBottomStuck = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTopStuck = _useState4[0],
    setIsTopStuck = _useState4[1];
  var deviceType = useDeviceType();
  var withSticky = useMemo(function () {
    return deviceTypesWithSticky ? deviceTypesWithSticky.includes(deviceType) : true;
  }, [deviceType, deviceTypesWithSticky]);
  var handleOnBottomStuck = function handleOnBottomStuck(isIntersecting) {
    onBottomStuck === null || onBottomStuck === void 0 ? void 0 : onBottomStuck(isIntersecting);
    setIsBottomStuck(isIntersecting);
  };
  var handleOnTopStuck = function handleOnTopStuck(isIntersecting) {
    onTopStuck === null || onTopStuck === void 0 ? void 0 : onTopStuck(isIntersecting);
    setIsTopStuck(isIntersecting);
  };
  return _objectSpread(_objectSpread({}, restProps), {}, {
    withSticky: withSticky,
    stickyClassNames: stickyClassNames,
    isBottomStuck: isBottomStuck,
    isTopStuck: isTopStuck,
    handleOnBottomStuck: handleOnBottomStuck,
    handleOnTopStuck: handleOnTopStuck
  });
};